import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { styled } from '@classify/react-core-components/styles';
import Box from '@classify/react-core-components/Box';
export interface Props {
  secondaryChildren?: ReactNode;
  children?: ReactNode;
  hasError?: boolean;
  variant?: 'discrete';
}
const ActionsWrapper = styled(Box)(({
  theme: {
    spacing,
    palette
  }
}) => ({
  padding: spacing(0.5, 1),
  backgroundColor: palette.layout.background.dashboard,
  borderTop: `1px solid ${palette.layout.line.divider}`,
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: spacing(2),
  '& .MuiButton-root + .MuiBox-root': {
    paddingTop: 0
  },
  '&.variant-discrete': {
    backgroundColor: palette.background.paper,
    borderTop: 'none'
  },
  '&.has-error': {
    backgroundColor: palette.form.field.background.error.enabled,
    borderColor: palette.notification.error.main
  }
}));
const ActionsContainer = styled('div')(({
  theme: {
    spacing,
    palette
  }
}) => ({
  display: 'flex',
  gap: spacing(2),
  alignItems: 'center',
  '& .Mui-disabled': {
    '& .MuiSvgIcon-root': {
      color: palette.interaction.disabled
    }
  }
}));
const SmartInputWrapperActions = t0 => {
  const $ = _c(12);
  const {
    secondaryChildren,
    children,
    hasError,
    variant
  } = t0;
  let classNames;
  if ($[0] !== hasError || $[1] !== variant) {
    classNames = [];
    if (hasError) {
      classNames.push("has-error");
    }
    if (variant) {
      classNames.push(`variant-${variant}`);
    }
    $[0] = hasError;
    $[1] = variant;
    $[2] = classNames;
  } else {
    classNames = $[2];
  }
  const t1 = classNames.join(" ");
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      flexGrow: 1
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== secondaryChildren) {
    t3 = <ActionsContainer sx={t2}>{secondaryChildren}</ActionsContainer>;
    $[4] = secondaryChildren;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== children) {
    t4 = <ActionsContainer>{children}</ActionsContainer>;
    $[6] = children;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4) {
    t5 = <ActionsWrapper className={t1}>{t3}{t4}</ActionsWrapper>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default SmartInputWrapperActions;